<template>
  <div>
    <div class="header">
      <div class="head-nav-left flex">
        <img :src="Boolean(!imgUrl) ?require('../assets/logo.png'):imgUrl" alt style="width:64px"/>
        <!-- <img :src="Boolean(!imgUrl) ?require('../assets/skinreader_logo_new_1_transpare.png'):imgUrl" alt style="width:210px; height=70"/> -->      
        <span style="white-space: nowrap"><h2>&nbsp;&nbsp;{{head_title}}{{version}}</h2></span>

      </div>
      <div class="head-nav-right">
        <ul style="display: flex; align-items: center; white-space: nowrap">
          <router-link
            to="/home/intell"
            tag="li"
            style="display: flex; align-items: center"
          >
            <i v-if="differentContent.showAiTitle" class="icon-ai">AI</i>
            <span class="itext" v-if="differentContent.showAiTitle"
              >智能诊断
            </span>
            <i
              v-if="!differentContent.showAiTitle"
              class="icon-ai iconfont"
              style="font-size: 24px"
              >&#xe753;</i
            >
            <!-- <span class="itext" v-if="!differentContent.showAiTitle">病&nbsp;&nbsp;历&nbsp;&nbsp;</span> -->
            <span class="itext" v-if="!differentContent.showAiTitle">影像检查</span>
          </router-link>

          <router-link  to="/home/patients"  tag="li" style="display: flex; align-items: center">
            <i style="font-size: 24px" class="iconfont icon-huanzheguan"></i>  <span class="itext">患者管理</span>
          </router-link>

          <router-link  to="/home/operation"  v-acl="['operation_order']"  tag="li" style="display: flex; align-items: center" >
            <i style="font-size: 24px" class="iconfont icon-shoushudeng"></i>   <span class="itext">手术管理</span>
          </router-link>

          <!-- <router-link to="/home/followup"  v-acl="['followup']"  tag="li" style="display:flex;align-items:center;">
            <span> <img src="../assets/iconfont/suifang2.svg" style="width:25px;height:auto;"></span>
            <span class="itext">科研随访</span>
          </router-link> -->
          <!-- // 临时注释 -->
          <router-link to="/home/hairdressing" v-acl="['export_cosmetology']" tag="li" style="display:flex;align-items:center;">
            <i style="font-size:24px" class='iconfont icon-35'></i> <span class="itext">美容/治疗</span>
          </router-link>

          <router-link  to="/home/cohort" v-acl="['cohort']" tag="li" style="display: flex; align-items: center">
            <i style="font-size: 24px" class="iconfont icon-duilieguanli"></i>  <span class="itext">科研队列</span>
          </router-link>          

          <router-link to="/home/cosmetregister"  v-acl="['export_cosmetology']"  tag="li" style="display:flex;align-items:center;">
            <i style="font-size:24px" class='iconfont icon-yuyue'></i> 
            <span class="itext">美容预约</span>
          </router-link>

          <router-link
            to="/home/image"
            tag="li"
            style="display: flex; align-items: center"
          >
            <i style="font-size: 24px" class="iconfont icon-tupian"></i>
            <span class="itext">高级搜索</span>
          </router-link>
          <router-link
            to="/home/homeInfo"
            tag="li"
            style="display: flex; align-items: center"
          >
            <i
              style="font-size: 24px"
              class="iconfont icon-tongjifenxi-copy"
            ></i>
            <span class="itext">统计数据</span>
          </router-link>
          <!-- // 临时注释 -->
          <!-- <router-link to="/home/test" tag="li" style="display:flex;align-items:center;">
                        <i style="font-size:24px" class='iconfont icon-tongjifenxi-copy'></i> <span class="itext">测试页面</span>
                    </router-link> -->
          <div
            class="user-btn"
            :class="{
              active:
                this.$route.path === '/home/user/account' ||
                this.$route.path === '/home/user/setting' ||
                this.$route.path === '/home/user/opinion' ||
                this.$route.path === '/home/user/result',
            }"
          >
            <div class="user-pic" ref="userPic"></div>
            <div class="user-name">{{ username }}</div>
            <div class="user-menu-box">
              <div class="user-menu-bg"></div>
              <ul class="user-menu">
                <router-link to="/home/user/account" tag="li"
                  ><span class="iconfont icon-users">&#xe63d;</span>我的账户
                </router-link>
                <router-link to="/home/user/setting" tag="li"
                  ><span class="iconfont">&#xe781;</span>系统设置</router-link
                >
                <router-link to="/home/user/opinion" tag="li"
                  ><span class="iconfont">&#xe622;</span>反馈意见</router-link
                >
                <li @click="lookVersion" v-if="differentContent.showVersion">
                  <span class="iconfont icon-banbenhao"></span>版本信息
                </li>
                <li @click="signOut">
                  <span class="iconfont icon-quit">&#xe668;</span>退出登录
                </li>
              </ul>
            </div>
          </div>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import api from "../api";
// import axios from 'axios';
import csrftoken from "../getToken";
import "../assets/iconfont/iconfont.css";
import gql from "graphql-tag";
import raceJs from '../race.js';

const differentContent = {};
if (process.env.VUE_APP_SHOW_INTEL === "yes") {
  // differentContent.showAiTitle = true;
  differentContent.showAiTitle = false;
  differentContent.showVersion = false;
} else {
  differentContent.showAiTitle = false;
  differentContent.showVersion = true;

}
export default {
  name: "HeaderNav",
  data() {
    return {
      differentContent,
      username: "",
      imgUrl: "",
      head_title: "问鼎皮肤智慧云·SkinReader",
      version: raceJs.version.split('-')[0], // v3.7.2-pre => v3.7.2
    };
  },
  async beforeCreate() {
    try {
      const response = await this.$apollo.query({
        query: gql`
          {
            me {
              username
              avatar
            }
          }
        `,
        fetchPolicy: "no-cache",
      });
      this.username = response.data.me.username;
      if (response.data.me.avatar !== "") {
        this.$refs.userPic.style.backgroundImage = `url(${
          api.doctor_header + response.data.me.avatar
        })`;
      }
    } catch (e) {
      if (
        e.message.split("error: ")[1] === "Cannot read property 'id' of null"
      ) {
        this.$message.error("请先登录");
        this.$router.push("/login");
      }
      if (e.message.split("error: ")[1] === "Unauthorized") {
        this.$message.error("请先登录");
        this.$router.push("/login");
      }
    }
  },
  async beforeMount() {
    const rep = await this.$apollo.query({
      query: gql`
        {
          me {
            id
            customer_logo
          }
        }
      `,
      fetchPolicy: "no-cache",
    });
    if (rep.data.me.customer_logo){
      this.imgUrl = api.server + "/doctor_images/" + rep.data.me.customer_logo+"?type=123";
    }
    console.log(this.imgUrl);
    // this.imgUrl = ""
  },
  async mounted() {
    let accountInfo = this.$store.state.accountInfo;
    if (!accountInfo || !accountInfo.head_title) {
      // 新标签页 store 为空，重新获取
      try {
        const res = await this.$apollo.query({
          query: gql`{ me { id leader_id } }`,
          fetchPolicy: 'no-cache'
        });
        const leader_id = res.data.me.leader_id;
        const accRes = await this.$apollo.query({
          query: gql`query($doctor_id: Int){ 
            accountInfo(doctor_id: $doctor_id){ head_title } 
            }`,
          variables: { doctor_id: leader_id },
          fetchPolicy: 'no-cache'
        });
        accountInfo = accRes.data.accountInfo;
        this.$store.commit('setAccountInfo', accountInfo);
      } catch (e) {
        // 获取失败，使用默认标题
      }
    }
    if (accountInfo.head_title) {
      this.head_title = accountInfo.head_title;
    }
  },
  methods: {
    lookVersion() {
      this.$alert(
        "<p>软件基本版本：V2</p><p>软件完整版本:V2.4.1</p>",
        "版本信息",
        {
          dangerouslyUseHTMLString: true,
        }
      );
    },

    async signOut() {
      try {
        const res = await this.$apollo.mutate({
          mutation: gql`
            mutation {
              doctorLogout
            }
          `,
        });
        if (res.data) {
          // 断开EventSource连接
          if (window.eventSrc) {
            window.eventSrc.close();
          }
          this.$store.commit("controller/sethasLogin", true);
          this.$store.commit("controller/setintellModel", []);
          this.$store.commit("controller/setauths", ["diagnoses_image"]);
          this.$store.commit(
            "controller/seteditDuration",
            7 * 24 * 3600 * 1000
          );
          this.$router.push("/login");
          this.$message({
            message: "退出成功",
            type: "success",
          });

          window.sessionStorage.clear();
        }
      } catch (error) {
        this.$message.error(error.message.split(":")[1]);
      }
    },
  },
};
</script>
<style scoped>
ul {
  margin: 0;
  padding: 0;
}
.itext {
  font-size: 17px;
  margin-left: 10px;
}
.header {
  background: linear-gradient(to left, #214855, #4da2bf);
  background: -ms-linear-gradient(to left, #214855, #4da2bf);
  background: -moz-linear-gradient(to left, #214855, #4da2bf);
  display: flex;
  align-items: center;
  height: 50px;
  justify-content: space-between;
}
.header div {
  margin-left: 20px;
  margin-right: 20px;
  color: white;
  font-size: 20px;
}
.header img {
  width: 40px;
  height: 30px;
}
.head-nav-right {
  list-style: none;
  margin-left: 20px;
  margin-right: 20px;
  color: white;
  font-size: 20px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
}
.head-nav-right ul li {
  float: left;
  margin-left: 20px;
  margin-right: 20px;
  padding: 6px;
  border-radius: 6px;
  cursor: pointer;
}
.active {
  background: #81a6b4;
}
.flex {
  display: flex;
  align-items: center;
}
.username {
  float: right;
}

.head-nav-right ul .user-btn {
  position: relative;
  padding: 3px 10px;
  min-width: 100px;
  height: 30px;
  border-radius: 10px;
  /* background-color: #6e93a0; */
}
.user-btn .user-pic {
  float: left;
  width: 30px;
  height: 30px;
  padding: 0;
  margin: 0 15px 0 6px;
  border-radius: 50%;
  background-size: 30px 30px;
  background-color: #ccc;
}
.user-btn .user-name {
  float: left;
  padding: 0;
  margin: 0;
  font-size: 16px;
  line-height: 30px;
}
.user-btn .user-menu-box {
  display: none;
  position: absolute;
  right: 0;
  top: 28px;
  width: 180px;
  margin: 0;
  padding: 0;
  z-index: 1000;
}
.user-btn .user-menu-box .user-menu-bg {
  padding: 0;
  margin: 0;
  height: 20px;
}
.user-btn .user-menu {
  width: 180px;
  margin: 0;
  padding: 0;
  border-radius: 8px;
  background-color: #214855;
  overflow: hidden;
}
.user-btn .user-menu li {
  display: flex;
  align-items: center;
  float: none;
  margin: 0;
  height: 30px;
  padding: 0 20px;
  border-radius: 0;
  font-size: 14px;
  line-height: 30px;
}
.user-btn .user-menu li .iconfont {
  margin-right: 20px;
}
.user-btn .user-menu li .icon-users {
  margin: 0 20px 0 1px;
}
.user-btn .user-menu li .icon-quit {
  margin: 0 20px 0 3px;
}
.user-btn .user-menu li + li {
  border-top: 1px solid #f2f2f2;
}
.user-btn .user-menu li:hover {
  background-color: #688d92;
}
.head-nav-right ul .user-btn:hover .user-menu-box {
  display: block;
}
</style>


